import React from "react";
import { downloadKycDoc, download_bulk_fundout_report } from "../../../services/manage-affiliate";
import { downloadFile } from "../../../common/download";
import { toast } from "react-toastify";
import { Context } from "../../../config/store";
import { viewOnboardingDoc } from "../../../services/onboarding-form-service";
import Modal from "../../../components/Modal";
import message from "../../../constant/message";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import Button from "../../../components/Common/Button";
import LenderUgroService from "../../../services/lender";
import { Tooltip } from "bootstrap";
import ReactTooltip from "react-tooltip";
const Actions = (props) => {
  return (
    <Download {...props} />
  );
};

export const Download = ({ title, row: { fundout_file_id, supporting_file }, row ,heading}) => {
  const { state } = React.useContext(Context);
  const [loading, setState] = React.useState(false);
  const location = useLocation();
  let lenderId = location.pathname.split('/')?.[3]

  if(heading === "credit"){
    heading = "credit";
  }
  if(heading === "operations"){
    heading = "ops";
  }
  if(heading === "nbfc"){
    heading = "fundout";
  }
  if(heading === "cersai"){
    heading = "cersai";
  }
  if(heading === "machinery"){
    heading = "machinery";
  }
  if(heading === "lap"){
    heading = "lap";
  }
  const downloadDoc = async (report_type,fundout_file_id) => {
    setState(true);
    try {
      const response = await download_bulk_fundout_report(
        state.userType,
        report_type,
        fundout_file_id,
        heading,
        lenderId
      );
      downloadFile(response?.data , `${report_type}_${heading}_${fundout_file_id}`);
    } catch (err) {
      toast.error(message.ERROR);
    }
    setState(false);
  };
  return (
    <div div className="d-flex">
      {!row?.inserted_record ?  "":
      <>
        <button className='btn  mx-1'
          onClick={() => downloadDoc('success',row?.fundout_file_id)}
          disabled={loading}
          data-for='Download-file'
          style={{ width: "30px", height: "30px", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#28a745" }} data-tip>
          <i class="fa fa-file" aria-hidden="true" style={{ color: "white" }}></i>
        </button>
        <ReactTooltip id='Download-file'>Inserted Record</ReactTooltip>
      </>
      }
      {!row?.updated_record ? "":
      <>
        <button className='btn btn-custom mx-1'
          onClick={() => downloadDoc('updated',row?.fundout_file_id)}
          disabled={loading}
          data-for='Download-file_update'
          style={{ width: "30px", height: "30px", display: "flex", justifyContent: "center", alignItems: "center",backgroundColor:'#17a2b8' }} data-tip>
          <i class="fa fa-file" aria-hidden="true"></i>
        </button>
        <ReactTooltip id='Download-file_update'>Updated Record</ReactTooltip>
      </>
      }
      {!row?.failed_record ? "":
      <>
        <button className='btn btn-custom mx-1'
          onClick={() => downloadDoc('failed',row?.fundout_file_id)}
          disabled={loading}
          data-for='Download-file_fail'
          style={{ width: "30px", height: "30px", display: "flex", justifyContent: "center", alignItems: "center",backgroundColor:'#dc3545' }} data-tip>
          <i class="fa fa-file" aria-hidden="true"></i>
        </button>
        <ReactTooltip id='Download-file_fail'>Failed Record</ReactTooltip>
      </>
      }
    </div>
  );
};

export default Actions;
